// extracted by mini-css-extract-plugin
export default {"container":"Switch_container__-jJVO","track":"Switch_track__w7dbG","thumb":"Switch_thumb__5htbz","containerOn":"Switch_containerOn__m12Fj"};